<template>
  <Page
    :loading="isLoadingPage"
    :spinning="isSpinning"
    class="base-table"
  >
    <PageTitle>API Nøgler</PageTitle>
    <p v-if="apiKeys.length === 0">
      Der er ingen oprettede API nøgler.
    </p>

    <div class="row">
      <div
        class="col-xs-12"
        v-if="apiKeys.length"
      >
        <div class="row bottom-xs base-table__header">
          <p class="col-xs-1">
            Status
          </p>
          <p class="col-xs-1">
            Udvidet
          </p>
          <p class="col-xs-3">
            Udstedt til
          </p>
          <p class="col-xs-5">
            Nøgle
          </p>
        </div>
        <Box
          v-for="(api, apiIndex) in apiKeys"
          :key="apiIndex"
          :open="api.editMode"
        >
          <div class="row">
            <div class="col-xs-1">
              {{ api.status | isActive }}
            </div>
            <div class="col-xs-1">
              {{ api.extended | isExtended }}
            </div>
            <div class="col-xs-3">
              {{ api.company }}
            </div>
            <div class="col-xs-5">
              {{ api.id }}
            </div>
            <div class="col-xs-2 end-xs">
              <font-awesome-icon
                class="base-table__icon-edit"
                icon="pencil-alt"
                @click="toggleEditMode(api)"
              />
              <font-awesome-icon
                class="base-table__icon-delete"
                icon="trash-alt"
                @click="deletePrompt(api)"
              />
            </div>
          </div>
          <div
            class="row"
            v-if="api.editMode"
          >
            <div class="col-xs-12">
              <UpdateAPIKeysForm :api="api" />
            </div>
          </div>
        </Box>
      </div>

      <div class="col-xs-12">
        <CreateAPIKeysForm @created="apiCreated" />
      </div>
    </div>
  </Page>
</template>

<script>
import Page from './Page.vue';
import UpdateAPIKeysForm from '../components/Forms/APIKeys/UpdateAPIKeysForm.vue';
import CreateAPIKeysForm from '../components/Forms/APIKeys/CreateAPIKeysForm.vue';
import Box from '../components/Box.vue';
import APIKeysService from '../services/APIKeysService';
import Pageload from '../mixins/Pageload';
import Request from '../mixins/Request';
import IsActive from '../filters/IsActive';
import IsExtended from '../filters/IsExtended';

export default {
    name: 'ApiKeys',
    mixins: [Pageload, Request],
    components: {
        Box, CreateAPIKeysForm, UpdateAPIKeysForm, Page,
    },
    filters: { IsActive, IsExtended },
    data() {
        return {
            apiKeys: [],
        };
    },
    methods: {
        toggleEditMode(api) {
            this.$set(api, 'editMode', !api.editMode);
        },
        apiCreated(api) {
            this.apiKeys.push(api);
        },
        async deleteAction(api) {
            try {
                const apiIndex = this.apiKeys.findIndex(a => a === api);
                if (apiIndex === -1) {
                    return;
                }
                await APIKeysService.delete(api);
                this.$delete(this.apiKeys, apiIndex);
                this.$snotify.success('Slettet.');
            } catch (error) {
                //
            }
        },
        deletePrompt(api) {
            this.$snotify.confirm(`Vil du slette ${api.company}?`, {
                timeout: 5000,
                buttons: [
                    {
                        text: 'Ja',
                        action: (toast) => {
                            this.deleteAction(api);
                            this.$snotify.remove(toast.id);
                        },
                        bold: false,
                    },
                    {
                        text: 'Fortryd',
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        },
                        bold: true,
                    },
                ],
            });
        },
        mapInitList(api) {
            return { ...api, editMode: false };
        },
    },
    async created() {
        try {
            await this.requestData({
                service: APIKeysService.getAll,
                storage: 'apiKeys',
                method: 'map',
                methodHandler: this.mapInitList,
            });
        } catch (error) {
            //
        }
    },
};
</script>
